import {combineReducers} from 'redux'
import userProps from './userReducer';
import userReducer from './userReducer';

const allReducers = combineReducers({
    userReducer,
    userProps
})
 
export default allReducers;